/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LSP7CompatibilityForERC20,
  LSP7CompatibilityForERC20Interface,
} from "../LSP7CompatibilityForERC20";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "address",
        name: "newOwner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "authorizedAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "LSP7AmountExceedsAuthorizedAmount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "LSP7AmountExceedsBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP7CannotSendWithAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP7CannotUseAddressZeroAsOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP7InvalidTransferBatch",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP7NotifyTokenReceiverContractMissingLSP1Interface",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP7NotifyTokenReceiverIsEOA",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AuthorizedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "RevokedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "authorizeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "isOperatorFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "revokeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amount",
        type: "uint256[]",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "transferBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class LSP7CompatibilityForERC20__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name_: string,
    symbol_: string,
    newOwner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LSP7CompatibilityForERC20> {
    return super.deploy(
      name_,
      symbol_,
      newOwner_,
      overrides || {}
    ) as Promise<LSP7CompatibilityForERC20>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    newOwner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      newOwner_,
      overrides || {}
    );
  }
  attach(address: string): LSP7CompatibilityForERC20 {
    return super.attach(address) as LSP7CompatibilityForERC20;
  }
  connect(signer: Signer): LSP7CompatibilityForERC20__factory {
    return super.connect(signer) as LSP7CompatibilityForERC20__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LSP7CompatibilityForERC20Interface {
    return new utils.Interface(_abi) as LSP7CompatibilityForERC20Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LSP7CompatibilityForERC20 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LSP7CompatibilityForERC20;
  }
}
